import { render, staticRenderFns } from "./DictionaryEditForm.vue?vue&type=template&id=64a8e7fc&scoped=true"
import script from "./DictionaryEditForm.vue?vue&type=script&lang=js"
export * from "./DictionaryEditForm.vue?vue&type=script&lang=js"
import style0 from "./DictionaryEditForm.vue?vue&type=style&index=0&id=64a8e7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a8e7fc",
  null
  
)

export default component.exports